import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Form from "../../../../components/Forms/Form";
import {
  alphaNumeric,
  required
} from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class ActionCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      // user: {},
      loading: false
    };
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    const { id } = this.props.match.params;
    if (id) {
      this.setState(
        () => ({
          loading: true
        }),
        () => {
          axios
            .get(`${URL.api}audict/action/singleView/${id}`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(resp => {
              if (resp.data.success) {
                this.setState(
                  () => ({
                    action: resp.data.data
                  }),
                  () => {
                    this.setState(() => ({
                      edit: true,
                      loading: false
                    }));
                  }
                );
              }
            });
        }
      );
    }
  }

  enviar(value) {
    let obj = {
      loggedUser: this.props.user.user.id,
      name: value.name
    };
    axios
      .post(`${URL.api}audict/action/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.props.history.push("/action/list");
      });
  }

  atualizar(value) {
    let obj = {
      loggedUser: this.props.user.user.id,
      name: value.name
    };
    axios
      .post(`${URL.api}audict/action/update/${value.id}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.props.history.push("/action/list");
      });
  }

  render() {
    const Fields = [
      {
        name: "name",
        label: "Ação",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required, alphaNumeric]
      }
    ];

    let buttons = [
      {
        name: "Enviar",
        submit: false,
        icon: "fa fa-cloud",
        iconSide: "left",
        custom: this.enviar,
        color: "primary"
      }
    ];
    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/action/list", to: "/action/list" }]}
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Form
            avatar
            fields={Fields}
            buttons={buttons}
            back
            history={this.props.history}
            onSubmit={this.state.edit ? this.atualizar : this.enviar}
            initialValues={this.state.action}
            edit={this.state.edit}
          />
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActionCreate);
